import GameOverviewResponse from "../../../../../state/interfaces/GameOverviewResponse";
import { GameState } from "../../../../../state/interfaces/GameState";
import { setActiveMapVariantFromGame } from "../../../../../map/variants";
import getPhaseKey from "../../../getPhaseKey";
import { handleGetSucceeded, handleGetFailed } from "../handleSucceededFailed";

/* eslint-disable no-param-reassign */
export default function fetchGameOverviewFulfilled(
  state: GameState,
  action,
): void {
  state.outstandingOverviewRequests = false;
  if (!action.payload) {
    handleGetFailed(state, action);
    return;
  }
  handleGetSucceeded(state);

  const response: GameOverviewResponse = action.payload;
  /*
   * overview 里已经带了 variant.id / mapID，这里就把当前地图切过去。
   * 之前只在 game/data 到达后才切，而国家表（WDCountryTable）在 overview
   * 到达后就会渲染 —— 那段时间用的还是 classic 的 7 国映射，
   * countryMap["Peru"] 之类的查询得到 undefined，紧接着 toUpperCase()
   * 抛异常，整页白屏。
   */
  setActiveMapVariantFromGame({
    variantID: response.variant?.id ?? response.variantID,
    mapID: response.variant?.mapID,
  });
  const oldPhaseKey = getPhaseKey(state.overview, "<BAD OVERVIEW_KEY>");
  const newPhaseKey = getPhaseKey(response, "<BAD OVERVIEW_KEY>");
  // console.log({ oldPhaseKey, newPhaseKey });
  // probably we only need to look at processTime, not phase key. But I'm leaving in the
  // phase key to be safe (since this is the historical way we did it).
  if (
    oldPhaseKey !== newPhaseKey ||
    state.overview.processTime !== response.processTime
  ) {
    state.needsGameData = true;
  }
  state.overview = response;
}
